import Axios from './APIService';
import { AxiosPromise } from 'axios';

import Order from '@/types/Order';
import Shipment from '@/types/Shipment';
import Payment from '@/types/Payment';
import ContactInfo from '@/types/ContactInfo';
import { OrderStatus } from '@/types/OrderStatus';
import PayPalInfo from '@/types/PayPalInfo';

const apiBase = '/orders';

const OrderAPI = {

    getAllOrders(): AxiosPromise<Order[]> {
        return Axios.get(`/admin${apiBase}`);
    },

    updateOrderStatus(orderId: string, orderStatus: OrderStatus): AxiosPromise<Order[]> {
        return Axios.patch(`/admin${apiBase}/${orderId}`, orderStatus);
    },

    cancelOrder(orderId: string): AxiosPromise<Order[]> {
        return Axios.delete(`/admin${apiBase}/${orderId}`);
    },

    get(): AxiosPromise<Order[]> {
        return Axios.get(apiBase);
    },

    getOrder(orderId: string): AxiosPromise<Order[]> {
        return Axios.get(`${apiBase}/${orderId}`);
    },

    post(order: Order): AxiosPromise<Order> {
        return Axios.post(apiBase, order);
    },

    putItem(orderId: string, itemId: string): AxiosPromise<Order> {
        return Axios.put(`${apiBase}/${orderId}/items/${itemId}`);
    },

    deleteItem(orderId: string, itemId: string): AxiosPromise<Order> {
        return Axios.delete(`${apiBase}/${orderId}/items/${itemId}`);
    },

    createShipping(orderId: string, shipment: Shipment): AxiosPromise<Order> {
        return Axios.post(`${apiBase}/${orderId}/shipment`, shipment);
    },

    updateShipment(orderId: string, shipment: Shipment): AxiosPromise<Order> {
        return Axios.post(`/admin${apiBase}/${orderId}/shipment/${shipment.shipmentId}`, shipment);
    },

    setPayment(orderId: string, payment: Payment): AxiosPromise<Order> {
        return Axios.put(`${apiBase}/${orderId}/payment`, payment);
    },

    completePaymentPayPal(orderId: string): AxiosPromise<PayPalInfo> {
        return Axios.get(`${apiBase}/${orderId}/payment/paypal`);
    },

    validatePaymentPayPal(orderId: string): AxiosPromise<string> {
        return Axios.get(`${apiBase}/${orderId}/payment/paypal/validate`);
    },

    setContactInfo(orderId: string, contactInfo: ContactInfo): AxiosPromise<Order> {
        return Axios.put(`${apiBase}/${orderId}/contact`, contactInfo);
    },

    setCouponCode(orderId: string, couponCode: string): AxiosPromise<Order> {
        if (!couponCode) {
            couponCode = '';
        }
        return Axios.put(`${apiBase}/${orderId}/coupon/${couponCode}`);
    },

    deleteCouponCode(orderId: string): AxiosPromise<Order> {
        return Axios.delete(`${apiBase}/${orderId}/coupon`);
    },

    complete(orderId: string): AxiosPromise<Order> {
        return Axios.put(`${apiBase}/${orderId}/complete`);
    },

    reSendEmail(orderId: string, mailType: string): AxiosPromise<Order> {
        return Axios.post(`/admin${apiBase}/${orderId}/email/${mailType}`);
    }

};

export default OrderAPI;
